import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './i18n'; // Initialize i18n
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Talks from './pages/Talks';
import VideoLibrary from './pages/VideoLibrary';
import Articles from './pages/Articles';
import DXN from './pages/DXN';
import Sunya from './pages/Sunya';
import Wellness from './pages/Wellness';
import Peace from './pages/Peace';
import Resources from './pages/Resources';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/about/:section" element={<About />} />
            <Route path="/talks" element={<Talks />} />
            <Route path="/talks/:category" element={<Talks />} />
            <Route path="/video-library" element={<VideoLibrary />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/:id" element={<Articles />} />
            <Route path="/dxn" element={<DXN />} />
            <Route path="/dxn/:section" element={<DXN />} />
            <Route path="/sunya" element={<Sunya />} />
            <Route path="/sunya/:section" element={<Sunya />} />
            <Route path="/wellness" element={<Wellness />} />
            <Route path="/wellness/:section" element={<Wellness />} />
            <Route path="/peace" element={<Peace />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;